export default __webpack_public_path__ + "static/media/seven-sisters.94a24cd6.webp";